export function createHealthCheckUrl(serviceName: string, gatewayUrl: string): string {
  if (!gatewayUrl || !serviceName) {
    throw new Error('Invalid gatewayUrl or serviceName');
  }
  const url = new URL(gatewayUrl);
  url.hostname = url.hostname.replace('gateway', serviceName);
  url.pathname = url.pathname.replace('/graphql', '/health-check');
  return url.toString();
}
